import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, EditableItem, ModuleFE_Toaster, TS_ErrorBoundary, TS_Tabs } from '@nu-art/thunderstorm-frontend';
import './Preview_Expression.scss';
import { ModuleFE_FloatingWindows, windowRect } from '@nu-art/floating-windows';
import { ICONS, Preview } from '@app/styles';
import { ModuleFE_Expression } from '../ModuleFE_Expression.js';
import { Component_ExpressionPrettyPrinter } from '../../../ui/expressions/ui/index.js';
import { Component_JSONPreview, Component_PyJsonPreview } from '../../../ui/expressions/ui/expression-builder/components/index.js';
export class Preview_Expression extends ComponentSync {
    static show = (expressionId) => {
        const expression = ModuleFE_Expression.cache.unique(expressionId);
        if (!expression)
            return ModuleFE_Toaster.toastError(`Could not open preview for expression, no variable with id ${expressionId} found`);
        const model = {
            key: `preview-${expressionId}`,
            className: 'preview-window',
            rect: windowRect.thirdScreen_Right(),
            moveable: true,
            resizable: true,
            content: (cb) => _jsx(Preview_Expression, { expression: expression, closePreview: cb })
        };
        ModuleFE_FloatingWindows.window.add(model);
    };
    // ######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        state.expression ??= new EditableItem(nextProps.expression).setSaveAction(async (i) => i);
        state.selectedTab ??= 'pretty-print';
        return state;
    }
    // ######################### Logic #########################
    getTabs = () => {
        return [
            {
                uid: 'pretty-print',
                title: 'Pretty Print',
                content: () => _jsx(TS_ErrorBoundary, { children: _jsx(Component_ExpressionPrettyPrinter, { editable: this.state.expression }) }),
            },
            {
                uid: 'json',
                title: 'JSON',
                content: () => _jsx(Component_JSONPreview, { editable: this.state.expression }),
            },
            {
                uid: 'py-json',
                title: 'PY JSON',
                content: () => _jsx(Component_PyJsonPreview, { editable: this.state.expression })
            }
        ];
    };
    // ######################### Render #########################
    render() {
        return _jsxs(Preview.Root, { className: 'preview__expression', children: [this.render_Header(), this.render_Main()] });
    }
    render_Header = () => {
        return _jsxs(Preview.Header, { children: [_jsx(Preview.HeaderTitle, { children: this.state.expression.item.label }), _jsx(Preview.HeaderTail, { children: _jsx(ICONS.advisor_avn_close.component, { onClick: this.props.closePreview }) })] });
    };
    render_Main = () => {
        const tabs = this.getTabs();
        return _jsx(Preview.Main, { children: _jsx(TS_Tabs, { tabs: tabs, selectedTabId: this.state.selectedTab, onSelected: tab => this.setState({ selectedTab: tab }) }) });
    };
}
//# sourceMappingURL=Preview_Expression.js.map